export default __webpack_public_path__ + "static/media/new-flag.434e2072.svg";